import React from 'react';

interface IconBlockProps {
  className?: string;
  size?: string;
}

const IconBlock = ({ className, size }: IconBlockProps) => {
  const Size = size ?? '20';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Size}
      height={Size}
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2M4 12c0-4.42 3.58-8 8-8c1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.9 7.9 0 0 1 4 12m8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.9 7.9 0 0 1 20 12c0 4.42-3.58 8-8 8"
      />
    </svg>
  );
};

export default IconBlock;
